import Cookies from 'js-cookie'
import { login, getStaffInfo } from '@/api/auth'
import { resetRouter } from '@/router'

const TOKEN_KEY = 'cloud_phone_admin_token'

const state = {
  token: Cookies.get(TOKEN_KEY) || '',
  userInfo: JSON.parse(localStorage.getItem('adminUserInfo') || '{}'),
  role: localStorage.getItem('adminRole') || '',
  permissions: JSON.parse(localStorage.getItem('adminPermissions') || '[]'),
  sidebar: { opened: true }
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      Cookies.set(TOKEN_KEY, token, { expires: 1 })
    } else {
      Cookies.remove(TOKEN_KEY)
    }
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
    localStorage.setItem('adminUserInfo', JSON.stringify(info))
  },
  SET_ROLE(state, role) {
    state.role = role
    localStorage.setItem('adminRole', role)
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions || []
    localStorage.setItem('adminPermissions', JSON.stringify(state.permissions))
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened
  }
}

const actions = {
  async login({ commit }, loginForm) {
    var res = await login(loginForm)
    var data = res.data || {}
    // 兼容两种返回格式：{ staff, token } 与 { adminInfo, token }
    var info = data.adminInfo || data.staff || {}
    // role 兼容字符串 role 与数组 roles[0]
    var role = info.role || (Array.isArray(info.roles) && info.roles.length ? info.roles[0] : '') || ''
    commit('SET_TOKEN', data.token)
    commit('SET_USER_INFO', info)
    commit('SET_ROLE', role)
    commit('SET_PERMISSIONS', info.permissions || [])
    return res
  },
  async getInfo({ commit, state }) {
    var res = await getStaffInfo()
    // getInfo 返回可能是 { staff } 或 { adminInfo } 或直接对象
    var staff = res.data.adminInfo || res.data.staff || res.data
    var role = staff.role || (Array.isArray(staff.roles) && staff.roles.length ? staff.roles[0] : '') || ''
    commit('SET_USER_INFO', staff)
    commit('SET_ROLE', role)
    commit('SET_PERMISSIONS', staff.permissions || [])
    return staff
  },
  logout({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', {})
    commit('SET_ROLE', '')
    commit('SET_PERMISSIONS', [])
    commit('permission/RESET_ROUTES', null, { root: true })
    localStorage.removeItem('adminUserInfo')
    localStorage.removeItem('adminRole')
    localStorage.removeItem('adminPermissions')
    resetRouter()
  },
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
